module.exports = __webpack_public_path__ + "img/avatar-s-21.a6c87117.jpg";